import React from 'react';
import { info, } from 'application/console';
import BaseComponent from 'application/baseComponent';
import { punditStore } from 'stores/punditStore';

export default class PunditMatchTimeComponent extends BaseComponent {

  constructor(props){
    super(props, [punditStore]);
  }

  getState(props){
    return {
      date: punditStore.matchDateTime,
    };
  }

  render(){
    return <p>{ this.state.date }</p>;
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditMatchTimeComponent.js